/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactFragment } from "react";

import { getLang, get } from "@/utils/use-lang";
import { GhostSettings } from "@/lib/ghost";
import { DocumentHead } from "@/components/Blog/DocumentHead";
import { SubscribeOverlay } from "@/components/Blog/SubscribeOverlay";
import { SubscribeSuccess } from "@/components/Blog/SubscribeSuccess";
import { StickyNavContainer } from "@/effects/StickyNavContainer";
import Footer from "../Footer";

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */

interface LayoutProps {
  settings: GhostSettings;
  header: ReactFragment;
  children: ReactFragment;
  isHome?: boolean;
  sticky?: StickyNavContainer;
  previewPosts?: ReactFragment;
  bodyClass: string;
  errorClass?: string;
}

export const Layout = ({
  settings,
  header,
  children,
  previewPosts,
  bodyClass,
  errorClass,
}: LayoutProps) => {
  const { lang } = settings;
  const text = get(getLang(lang));
  const site = settings;
  const title = text(`SITE_TITLE`, site.title);
  const { memberSubscriptions } = settings.processEnv;

  errorClass = errorClass || ``;

  return (
    <>
      <DocumentHead className={bodyClass} />

      <div className="site-wrapper">
        {/* The main header section on top of the screen */}
        {header}
        {/* The main content area */}
        <main id="site-main" className={`site-main outer ${errorClass}`}>
          {/* All the main content gets inserted here, index.js, post.js */}
          {children}
        </main>
        {/* Links to Previous/Next posts */}
        {previewPosts}

        {/* The footer at the very bottom of the screen */}
        <Footer />
        {/* <footer className="site-footer outer">
          <div className="site-footer-content inner">
            <section className="copyright">
              <a href={resolve(siteUrl, "")}>{title}</a> &copy;{" "}
              {new Date().getFullYear()}
            </section>

            <nav className="site-footer-nav">
              <Link href={Links.INDEX}>
                <a>{text(`LATEST_POSTS`)}</a>
              </Link>
              {site.facebook && (
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
                  Facebook
                </a>
              )}
              {site.twitter && (
                <a href={twitterUrl} target="_blank" rel="noopener noreferrer">
                  Twitter
                </a>
              )}
              <a
                href="https://www.jamify.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                Jamify
              </a>
            </nav>
          </div>
        </footer> */}
      </div>

      {memberSubscriptions && <SubscribeSuccess {...{ title, lang }} />}

      {/* The big email subscribe modal content */}
      {memberSubscriptions && <SubscribeOverlay {...{ settings }} />}
    </>
  );
};
